import { z } from 'zod';
import { colorHexPattern } from './regex';
import { UUIDValidationSchema } from './uuid';
const SiteProfileValidationSchema = z.object({
    coordinates: z.array(z.array(z.number()).length(2)).min(1)
});
const CreateSiteValidationSchema = z.object({
    workshop: UUIDValidationSchema,
    title: z.string(),
    description: z.string().optional(),
    coordinates: z.array(z.array(z.number()).length(2)).min(1),
    color: z.string().regex(colorHexPattern, 'not a valid hex color'),
    budget: z.number().min(0).optional()
});
const SiteValidationSchema = CreateSiteValidationSchema.extend({
    createdBy: z.string(),
    creatorName: z.string().optional()
});
export { CreateSiteValidationSchema, SiteProfileValidationSchema, SiteValidationSchema };
//# sourceMappingURL=site.js.map